// @ts-ignore
import { v4 as uuidv4 } from 'uuid'

export const generateRandomUuid = () => uuidv4()

export const toShortUuid = (uuid: string) => {
  return uuid.substr(0, 8)
}
